module.exports = __webpack_public_path__ + "assets/img/report_l3.3fab2716.png";